import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { HydraCollection } from '../hydra/hydra-collection';
import { map } from 'rxjs/operators';
import { CourseModel } from '../models/course/course.model';
import { SeriesModel } from '../models/course/series.model';

@Injectable({
  providedIn: 'root'
})
export class CourseApiService extends ApiService {
  readonly resourcePath = 'courses';

  list(filters: Record<string, string> = {}): Observable<HydraCollection<CourseModel>> {
    return this.restList<CourseModel>(filters);
  }

  getCourses(minified:boolean = false){
    if(minified){
      return this.http.get(this.apiUrl +'/me/courses/overview?minified=true');
    } else {
      return this.http.get(this.apiUrl +'/me/courses/overview');
    }
  }

  // Unified, server-merged/sorted course overview. scope filters to current/finished (omit for everything);
  // all variants are paged and accept a free-text search filter.
  getDashboardCourses(scope:'current'|'finished'|null = null, page:number = 1, limit:number = 6, search:string = ''){
    const params:string[] = ['page=' + page, 'limit=' + limit];
    if(scope){
      params.push('scope=' + scope);
    }
    if(search){
      params.push('search=' + encodeURIComponent(search));
    }
    return this.http.get(this.apiUrl + '/me/courses/dashboard?' + params.join('&'));
  }

  getFiles(seriesId:string){
    return this.http.get(this.apiUrl +'/me/media/coursefiles?series='+seriesId);
  }
  
  getCertificates(seriesId:string){
    return this.http.get(this.apiUrl +'/me/media/certificates?series='+seriesId);
  }
  getPersonalCertificates(){
    return this.http.get(this.apiUrl +'/me/media/certificates');
  }
  getPersonalFiles(){
    return this.http.get(this.apiUrl +'/me/media/coursefiles');
  }

  getSeries(id: string): Observable<HydraCollection<SeriesModel>> {
    return this.http.get<HydraCollection<SeriesModel>>(this.resourceUrl +'/'+ id +'/series').pipe(
      map(response => new HydraCollection<SeriesModel>(response))
    );
  }

  get(id: string): Observable<CourseModel> {
    return this.restRead<CourseModel>(id);
  }

  create(course: object): Observable<CourseModel> {
    return this.restCreate<CourseModel>(course);
  }

  update(id: string, course: object): Observable<CourseModel> {
    return this.restUpdate<CourseModel>(id, course);
  }

  exportDegreesPerEnrolment(enrolment:string, forceRegenerate:boolean = false): Observable<Blob> {
    let url:string = this.resourceUrl+'/exportDegrees?enrolmentId='+ enrolment +'&ids=[]';
    if(forceRegenerate){
      url += "&forceRegenerate=1"
    }
    return this.http.get(url, { responseType: 'blob'});
  }

  exportDegreesForStudent(enrolment:string, forceRegenerate:boolean = false): Observable<Blob> {
    let url:string = this.resourceUrl+'/exportDegrees?enrolmentId='+ enrolment +'&ids=[]';
    if(forceRegenerate){
      url += "&forceRegenerate=1"
    }
    return this.http.get(url, { responseType: 'blob'});
  }
}
